export default __webpack_public_path__ + "static/media/desktop-main-artist-image.a3fa5a13.jpg";